export { default } from './TooltipedSortLabel';
